<template>
    <input class="v-input" :class="{ 'v-input--error': error }" :value="value" v-on="listeners" />
</template>

<script>
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
class VInput extends Vue {
    @Prop({ type: [Boolean, String], default: false })
    error;

    @Prop({ type: [String, Number, Boolean], default: '' })
    value;

    get listeners() {
        return {
            ...this.$listeners,
            input: this.inputHandler,
            change: this.changeHandler,
        };
    }

    @Emit('input')
    inputHandler(event) {
        return event.target.value;
    }

    @Emit('change')
    changeHandler(event) {
        return event.target.value;
    }
}

export default VInput;
</script>

<style lang="scss">
$input-border-radius: 0.5rem;

:root {
    @include defineColor(--input-background-color, var(--color-white));
    @include defineColor(--input-text-color, var(--text-black));
    @include defineColor(--input-placeholder-color, #aaaaaa);
    @include defineColor(--input-border-color, #e5e4e5);

    @include defineColor(--input-disabled-placeholder-color, #d4d5d5);
    @include defineColor(--input-disabled-background-color, #f8f8f8);

    @include defineColor(--input-error-color, var(--color-red));
}

.v-input {
    width: 100%;
    height: 3rem;
    padding: 0.5rem 1rem;

    background-color: var(--input-background-color);
    border-radius: $input-border-radius;
    border: 0.0625rem solid var(--input-border-color);

    appearance: none;
    transition: border-color 0.15s;

    font-family: inherit;
    font-weight: 400;
    color: var(--input-text-color);
    font-size: 0.875rem;

    &::placeholder {
        color: var(--input-placeholder-color);
    }

    &:focus {
        outline: none;
        border-color: var(--color-control-active);
    }

    &:disabled,
    &[disabled] {
        background-color: var(--input-disabled-background-color);
        color: hsla(0, 0%, 50%, 1);

        &::placeholder {
            color: var(--input-disabled-placeholder-color);
        }
    }

    &--error {
        border-color: var(--input-error-color) !important;
    }

    // Static classes
    &--search {
        font-size: 1.125rem;
        padding: 0.875rem 0 0.875rem 3.125rem;
    }
}
</style>
